export default {
  getGallery: (state) => state.gallery,
};
